import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WeddingPalace from "@/components/WeddingPalace";
import WeddingFeatures from "@/components/WeddingFeatures";
import WeddingGallery from "@/components/WeddingGallery";
import StayAndEvent from "@/components/StayAndEvent";
import Owner from "@/components/Owner";
import About from "@/components/About";
import Rooms from "@/components/Rooms";
import Amenities from "@/components/Amenities";
import Reviews from "@/components/Reviews";
import Location from "@/components/Location";
import Contact from "@/components/Contact";
import FloatingActions from "@/components/FloatingActions";
import Footer from "@/components/Footer";

function Home() {
  return (
    <div className="App bg-background text-foreground">
      <Navbar />
      <main>
        {/* PRIMARY: Wedding Palace / Kalyana Mandap */}
        <Hero />
        <WeddingPalace />
        <WeddingFeatures />
        <WeddingGallery />
        <StayAndEvent />

        {/* Trust building: Founder profile */}
        <Owner />

        {/* SECONDARY: Guest House / Stay */}
        <About />
        <Rooms />
        <Amenities />

        {/* Social proof + booking */}
        <Reviews />
        <Location />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
      <Toaster position="bottom-center" richColors closeButton />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
